import Belief from './Belief';

export default Belief;
